import { FunctionComponent, ReactElement, ReactNode } from 'react';
import { useFormContext } from 'react-hook-form';
import { Stack, useBreakpointValue, VStack } from '@chakra-ui/react';

import Button from '../../../../../components/_core/Button';
import {
  BeneficiaryFormOutput,
  BeneficiarySchema,
  BeneficiarySchemaWithEmail,
} from '../beneficiarySchema';
import { adaptBeneficiaryFormToEntity } from '../helpers';

interface BeneficiaryFormWrapperProps {
  children: ReactNode;
  primaryAction: {
    title: string;
    onSubmit: (formValues: BeneficiaryFormOutput) => void;
    isSending: boolean;
    isDisabled?: boolean;
  };
  secondaryAction: ReactElement;
}

const BeneficiaryFormWrapper: FunctionComponent<
  BeneficiaryFormWrapperProps
> = ({ children, primaryAction, secondaryAction }) => {
  const { handleSubmit } = useFormContext<
    BeneficiarySchema | BeneficiarySchemaWithEmail,
    BeneficiaryFormOutput
  >();

  const isMobile = useBreakpointValue({ base: true, md: false });

  return (
    <VStack
      align="stretch"
      as="form"
      height="full"
      onSubmit={(event) => {
        event.preventDefault();
        handleSubmit((formValues) => {
          primaryAction.onSubmit(adaptBeneficiaryFormToEntity(formValues));
        })();
      }}
    >
      {children}
      <Stack
        alignContent="flex-end"
        direction={isMobile ? 'column' : 'row'}
        flexDirection={isMobile ? 'column-reverse' : 'row'}
        justifyContent="flex-end"
        marginTop="space-48"
        paddingBottom="space-48"
        spacing="space-16"
      >
        {secondaryAction}
        <Button
          isDisabled={primaryAction.isDisabled}
          isLoading={primaryAction.isSending}
          type="submit"
        >
          {primaryAction.title}
        </Button>
      </Stack>
    </VStack>
  );
};

export default BeneficiaryFormWrapper;
